import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { GetVehicleTypeListPagingAndFilterRequest, initialGetVehicleTypeListPagingAndFilterRequest } from '../../../models/request/vehicleType/GetVehicleTypeListPagingAndFilterRequest';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetConstantListResponse, GetConstantListResponseItem } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { DeleteVehicleTypeResponse } from '../../../models/response/vehicleType/DeleteVehicleTypeResponse';
import VehicleTypeListFilters from './Components/VehicleTypeListFilters';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, foldText } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';

const VehicleTypeList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Genel Tanımlamalar > Araç Cinsi Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetConstantListResponseItem[]>([]);
    const [filter, setFilter] = useState<GetVehicleTypeListPagingAndFilterRequest>(initialGetVehicleTypeListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Araç Cinsi Resimi', name: 'vehicleTypeImage', order: 0, isVisible: true },
            { title: 'Araç Cinsi Adı', name: 'value', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteVehicleType = async () => {
        try {
            var selectedIds = data.filter(x => x.isSelected).map(x => x.constantId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteVehicleTypeResponse = await ConstantService.deleteConstant(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateVehicleType = async (_id: string | undefined = undefined) => {
        navigate('/vehicleType/listadd?id=' + (_id ? _id : data.filter(x => x.isSelected)[0].constantId));
    }

    const getData = async (_filter: GetVehicleTypeListPagingAndFilterRequest | undefined = undefined) => {
        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetConstantListResponse = await ConstantService.getConstantList('VEHICLE_TYPE');

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            // Araç cinsi listesinin tamamı gelir; kolon filtreleri tarayıcıda uygulanır
            // (bkz. filteredData). Arama kutusu kaldırıldı.
            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData(data.map(function (x) {
            if (x.constantId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    // Kolon başlıklarının altındaki filtreler. Liste küçük ve tamamı tarayıcıda olduğu
    // için sunucuya istek atılmaz; metin kolonlarında büyük/küçük ve Türkçe harf farkı
    // gözetilmeden "içerir" araması yapılır (sunucudaki metin filtresiyle aynı kural).
    // Resim kolonu filtresiz.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        value: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    const textOf = (item: GetConstantListResponseItem, column: string): string => {
        if (column == 'value')
            return item.value ?? '';
        if (column == 'createdUser')
            return item.createdUser ?? '';
        if (column == 'updatedUser')
            return item.updatedUser ?? '';
        return '';
    }

    const filteredData = data.filter(item => (filter.columnFilters ?? []).every(f => {
        if (!columnFilterDefinitions[f.column])
            return true;

        var aranan = foldText((f.text ?? '').trim());

        return aranan == '' || foldText(textOf(item, f.column)).includes(aranan);
    }));

    // Filtre değişince görünmeyen satırlar seçili kalmasın (Sil/Güncelle yalnız görünenlere).
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        setFilter({ ...filter, columnFilters: columnFilters });
        setData(data.map(x => ({ ...x, isSelected: false })));
    }

    const selectAll = () => {
        var isAllSelected = filteredData.filter(x => x.companyId).length == filteredData.filter(x => x.companyId && x.isSelected).length;
        var visibleIds = filteredData.map(x => x.constantId);

        setData(data.map(function (x) {
            if (x.companyId && visibleIds.includes(x.constantId))
                x.isSelected = !isAllSelected;

            return x;
        }))
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const getColumnValue = (item: GetConstantListResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "vehicleTypeImage") {
            return (
                <td className={className} style={{ width: '1px' }}>
                    <img onClick={() => dispatch(storeImageViewer([item.additionalValue2 ? item.additionalValue2 : Helpers.getPlaceholder()]))} style={{ maxWidth: 75 }} className="actionIcon img img-thumbnail" src={item.additionalValue2 ? item.additionalValue2 : Helpers.getPlaceholder()} />
                </td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.constantId)} onDoubleClick={!item.companyId ? undefined : () => updateVehicleType(item.constantId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.constantId)} onDoubleClick={!item.companyId ? undefined : () => updateVehicleType(item.constantId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.constantId)} onDoubleClick={!item.companyId ? undefined : () => updateVehicleType(item.constantId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <VehicleTypeListFilters
                    columns={columns}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    selectedCount={data.filter(x => x.isSelected).length}
                    deleteFunction={deleteVehicleType}
                    updateFunction={updateVehicleType}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    {/* Arama kutusu ve Güncelle / Sil düğmeleri üst şeride taşındı (standart). */}
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={filteredData.filter(x => x.isSelected).length > 0 && filteredData.filter(x => x.isSelected).length == filteredData.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th>{item.title}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        filteredData.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        filteredData.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.constantId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default VehicleTypeList;